import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import DocumentMeta from 'react-document-meta';//Used for inegration of medtadata for SEO 


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
